import { useDebouncedCallback } from '@mantine/hooks';
import { setModelsModalState, useModelsModalState } from '../store/state';
import React, { useEffect } from 'react';

const debounceTime = 100; // 高频一点无所谓，只有变动才setModelsModalState

export const useScrollTop = (ref) => {
  useEffect(() => {
    setModelsModalState({
      isInScrolling: false,
    });
  }, []);
  const isInScrolling = useModelsModalState('isInScrolling');
  const scroll = useDebouncedCallback(() => {
    const isScroll = ref?.current?.scrollTop > 0;
    if (isInScrolling !== isScroll) {
      setModelsModalState({
        isInScrolling: isScroll,
      });
    }
  }, debounceTime);
  return { scroll };
};
